/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationDocumentResponseBaseResponse as ModelsV3ApplicationApplicationDocumentResponseBaseResponse } from '../../models/Models/v3/Application/application-document-response-base-response';

export interface V3ApplicationsDocumentsSummaryGet$Json$Params {
  applicationId?: string;
}

export function v3ApplicationsDocumentsSummaryGet$Json(http: HttpClient, rootUrl: string, params?: V3ApplicationsDocumentsSummaryGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationApplicationDocumentResponseBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3ApplicationsDocumentsSummaryGet$Json.PATH, 'get');
  if (params) {
    rb.query('applicationId', params.applicationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV3ApplicationApplicationDocumentResponseBaseResponse>;
    })
  );
}

v3ApplicationsDocumentsSummaryGet$Json.PATH = '/v3/applications/documents/summary';
